module.exports = __webpack_public_path__ + "static/art-direction-mobile-3405ec13b6d69d047c0f16eaaa287130.jpg";